export default "__VITE_ASSET__ZOXMYRaf__"